import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompaniesEntity } from '../../domain/entities/CompaniesEntity'
import type { CompanyAdminDto } from '@/backend/market'

export class CompaniesModel extends CompaniesEntity {
  constructor(dataDto: CompanyAdminDto) {
    super()
    mapEntityProperties<CompaniesModel>(this, dataDto, {
      exclude: ['service', 'mealTier'],
      map: {
        service: {
          id: dataDto.serviceId,
          name: dataDto.serviceName
        },
        mealTier: {
          id: dataDto.mealTierId,
          name: dataDto.mealTierName
        },
      
      }
    })
  }
}